/**
 * @file index.tsx
 *
 * @fileoverview A wrapper to include multiple form actions inside.
 */

import { cva, VariantProps } from "class-variance-authority";
import React from "react";
import styles from "./formActions.module.scss";

const formActionsWrapper = cva([styles.formActionsWrapper], {
  variants: {
    orientation: {
      left: styles.orientationLeft,
      right: styles.orientationRight,
    },
  },
  defaultVariants: {
    orientation: "left",
  },
});
export interface FormActionsProps
  extends VariantProps<typeof formActionsWrapper> {
  /**
   * The form elements to be added in the FormActions.
   */
  children: React.ReactNode;
}

/**
 * The form actions component allows grouping multiple form actions.
 * Usefull to group together a submit and  cancel button on a form for example.
 */
export default function FormActions({
  children,
  orientation = "left",
}: FormActionsProps) {
  return <div className={formActionsWrapper({ orientation })}>{children}</div>;
}
export { FormActions };
